/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  EDocRestService,
  EDocSigningStatus,
  EDocType,
  SalesFolderEDocRestService,
} from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';

export type EDocDetailsDialogConfig = { documentId: ID };

@Injectable()
export class EDocDetailsBusinessService implements InitDialogViewService<EDocDetailsDialogConfig> {
  constructor(private edocRest: EDocRestService,
              private salesFolderEDocRest: SalesFolderEDocRestService,
              private dictionaries: DictionaryService) {
  }

  initDialogView(route: DialogRouteSnapshot<EDocDetailsDialogConfig>): any {
    return {
      edocTypeDict: this.dictionaries.getByEnum(EDocType),
      signingStatusDict: this.dictionaries.getByEnum(EDocSigningStatus),
      document: this.edocRest.get(route.input.documentId),
    };
  }
}
